import { useState } from "react";
import { useTranslation } from "react-i18next";

import { InterviewService } from "../../../services/InterviewService";

import "./styleDocuments.scss";
import UploadBase64 from "../../../components/Files/FileBase64";
import IconClear from "../../../layout/others/icon_clear.svg";
import { useGeneralContext } from "../../General/Context";
import { toast } from "react-toastify";
import Select from "../../../components/Select";
import DocumentsDetailSection from "./Simulations/DocumentsDetailSection";

export default function Documents({
  fromUrl,
  interview,
  disabled,
  updateDocumentsGrid,
  setUpdatesDocumentsGrid,
  documentLanguages,
  documentTypes
}) {
  const { userInformation } = useGeneralContext();
  const { t } = useTranslation();
  const [file, setFile] = useState({});
  const [errors, setErros] = useState({});

  function onChange({ target }) {
    setFile({ ...file, [target.name]: Number(target.value) });
  }
  function refreshDocuments() {
    setUpdatesDocumentsGrid(!updateDocumentsGrid);
  }

  function uploadFile() {
    if (validateUpload()) return;
    InterviewService.uploadDocument(
      { ...file, interviewId: interview.interviewId },
      "vitae/interview/uploadDocument"
    ).then((data) => {
      setUpdatesDocumentsGrid(!updateDocumentsGrid);
      setFile({});
      toast.success(t("DocOnline successfully created"));
    });
  }

  function onFileLoad(fileBase64) {
    setFile({ ...file, fileBase64: fileBase64[0] });
  }

  function deleteFile() {
    setFile({ ...file, fileBase64: undefined });
    document.getElementById("file").value = "";
  }

  function validateUpload() {
    let errors = {};
    if (!file.documentTypeId) {
      errors.documentTypeId = t("The document type is required.");
    }
    if (!file.languageId)
      errors.languageId = t("The language field is required.");

    if (!file.fileBase64) {
      errors.file = t("The file upload is required.");
    }
    setErros(errors);

    return Object.keys(errors).length > 0;
  }
  return (
    <div className="row">
      {!disabled && (
        <div className="row">
          <div className="col adjust-fields-documents">
            <div className="col">
              <div className="col text-end-document-type">
                <label className="col-form-label col text-nowrap">
                  {t("Document Type")}*
                </label>
                {errors.documentTypeId && (
                  <div className="error-msg">{errors.documentTypeId}</div>
                )}
              </div>
              <div className="col">
                <div className="col form-group">
                  <Select
                    className="form-select"
                    value={file.documentTypeId || ""}
                    onChange={onChange}
                    name="documentTypeId"
                    required
                    style={{ width: "400px" }}
                    title={t("Selecione um item da lista.")}
                    disabled={disabled}
                  >
                    <option disabled></option>
                    {documentTypes?.map((type) => (
                      <option key={type.id} value={type.id}>
                        {t(type.description)}
                      </option>
                    ))}
                  </Select>
                </div>
                <div className="col">
                  <label className="col-form-label col text-nowrap">
                    {t("Language")}*
                  </label>
                  {errors.languageId && (
                    <div className="error-msg">{errors.languageId}</div>
                  )}
                </div>
                <div className="col adjust-field-language form-group">
                  <Select
                    className="form-select"
                    value={file.languageId || ""}
                    onChange={onChange}
                    required
                    name="languageId"
                    style={{ width: "400px" }}
                    title={t("Selecione um item da lista.")}
                    disabled={disabled}
                  >
                    <option selected disabled></option>
                    {documentLanguages?.map((lang) => (
                      <option key={lang.id} value={lang.id}>
                        {t(lang.description)}
                      </option>
                    ))}
                  </Select>
                </div>
              </div>
            </div>
          </div>
          <div className="col adjust-upload-documents">
            <div className="col width-upload-documents">
              <UploadBase64
                afterLoadCallback={onFileLoad}
                accept="application/pdf, application/msword, text/xml, application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
                multiple={false}
              />
              <div className="upload-result-wrapper">
                <label className="filename">{file.fileBase64?.fileName}</label>
                {file.fileBase64 && (
                  <button
                    title={t("Delete file")}
                    type="button"
                    className="action-button"
                    onClick={deleteFile}
                  >
                    <img src={IconClear} alt="delete" />
                  </button>
                )}
                {errors.file && <div className="error-msg">{errors.file}</div>}
              </div>
            </div>
            <div className="text-end width-upload-documents">
              <button
                onClick={uploadFile}
                className="app-button btn-prime btn-sm"
              >
                {t("Upload")}
              </button>
            </div>
          </div>
        </div>
      )}
      <DocumentsDetailSection
        interview={interview}
        fromUrl={fromUrl}
        permissions={userInformation.permissions}
        interviewId={interview?.interviewId}
        updateDocumentsGrid={updateDocumentsGrid}
        refreshDocuments={refreshDocuments}
      />
    </div>
  );
}
